module.exports = __webpack_public_path__ + "static/media/phonecall.bc2a5563.png";